import React, { FC, useEffect, useRef } from 'react';
import { Toast as PrimeToast } from 'primereact/toast';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primeicons/primeicons.css';

export type ToastProps = {
  type: 'success' | 'error' | 'info' | 'warn';
  message: string;
}

const Toast: FC<ToastProps> = ({ type, message }) => {
  const toast = useRef<PrimeToast>(null);

  useEffect(() => {
    toast.current?.show({ severity: type, detail: message, life: 80000 });
  }, []);

  return (
    <PrimeToast
      pt={{
        detail: { className: 'mt-0' },
        content: { className: 'border-0' },
      }}
      ref={toast}
    />
  );
};

export default Toast;
